export function camelCaseToWords(camelCaseString: string): string {
  if (!camelCaseString) {
    return "";
  }
  const spacedString = camelCaseString.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
  return spacedString.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function snakeCaseToWords(snakeCaseString: string): string {
  if (!snakeCaseString) {
    return "";
  }

  const spacedString = snakeCaseString.replace(/_/g, " ");

  return (
    spacedString.charAt(0).toUpperCase() + spacedString.slice(1).toLowerCase()
  );
}

export function isTextLikelyEnglish(text: string): boolean {
  const hasOnlyValidChars = /^[a-zA-Z\s.,'’!?-]*$/.test(text);
  const hasAtLeastOneWord = /\b[a-zA-Z]{2,}\b/.test(text);
  return hasOnlyValidChars && hasAtLeastOneWord;
}

export function validatePhoneNumberWithCountryCode(
  phoneNumber: string,
): boolean {
  return /^\+[1-9]\d{1,14}$/.test(phoneNumber);
}

export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
